const NAV = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/#services" },
  { label: "Testimonials", href: "/testimonials" },
  { label: "Achievements", href: "/achievements" },
  { label: "Blog", href: "/blog" },
  { label: "Login", href: "/login" },
];

export const SiteHeader = () => (
  <header className="border-b border-[#E5E7EB] sticky top-0 bg-white/90 backdrop-blur z-50" data-testid="site-header">
    <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
      <a href="/" data-testid="site-header-logo" className="font-head font-black text-base sm:text-lg tracking-tight shrink-0">
        The Next Move<span className="text-[#D94833]"> by Rhellex</span>
      </a>
      <nav className="flex items-center gap-1 sm:gap-2 overflow-x-auto no-scrollbar" data-testid="site-header-nav">
        {NAV.map((item) => (
          <a
            key={item.label}
            href={item.href}
            data-testid={`site-nav-${item.label.toLowerCase()}`}
            className="whitespace-nowrap px-3 py-2 rounded-full text-sm font-semibold text-[#3A4A63] hover:bg-[#041C3E] hover:text-white transition-colors"
          >
            {item.label}
          </a>
        ))}
      </nav>
    </div>
  </header>
);
